import { Card, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import dayjs from "dayjs";
import moment from "moment";
import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import Page from "../../core/components/Page";
import { getUsageStatistics } from "../../services/record.service";
import useAuth from "../../hooks/useAuth";

export default function Statistic() {
  const dateFormat = "YYYY-MM-DDTHH:mm:ss.SSSSSS[Z]";
  const [selectedRange, setSelectedRange] = useState<string>("monthly");

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const [usages, setUsages] = useState<any>([]);
  const {companyInfo} = useAuth();


  const handleRangeChange = (event: any) => {
    setSelectedRange(event);
    let sinceDate;
    switch (event) {
      case "monthly":
        sinceDate = dayjs().subtract(1, "month").format(dateFormat);
        break;
      case "3months":
        sinceDate = dayjs().subtract(3, "month").format(dateFormat);
        break;
      case "6months":
        sinceDate = dayjs().subtract(6, "month").format(dateFormat);
        break;
      case "yearly":
        sinceDate = dayjs().subtract(1, "year").format(dateFormat);
        break;
      default:
        sinceDate = dayjs().format(dateFormat);
    }
    handleGetUsageStats(sinceDate, dayjs().format(dateFormat));
  };

  useEffect(() => {
    handleRangeChange("monthly");
  }, []);

  const data = {
    labels: usages?.payload?.events?.map((event: any) =>
      moment(event?.ts).format("DD/MM/YYYY")
    ),
    datasets: [
      {
        label: "Toplam Dosya Boyutu (MB)",
        data: usages?.payload?.events?.map((event: any) =>
          (
            event?.data?.event_specific_data?.total_received_bytes /
            (1024 * 1024)
          ).toFixed(2)
        ),
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
      {
        label: "Toplam Dosya Süresi (saniye)",
        data: usages?.payload?.events?.map(
          (event: any) =>
            event?.data?.event_specific_data?.total_received_duration
        ),
        backgroundColor: "rgba(153, 102, 255, 0.2)",
        borderColor: "rgba(153, 102, 255, 1)",
        borderWidth: 1,
      },
      {
        label: "Toplam Konuşma Süresi (saniye)",
        data: usages?.payload?.events?.map(
          (event: any) =>
            event?.data?.event_specific_data?.total_speech_duration
        ),
        backgroundColor: "rgba(255, 159, 64, 0.2)",
        borderColor: "rgba(255, 159, 64, 1)",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top" as const,
      },
      title: {
        display: true,
        text: "Kullanım İstatistikleri",
      },
    },
  };

  const handleGetUsageStats = async (since: string, until: string) => {
    const response = await getUsageStatistics(since, until, companyInfo?.department_id);
    setUsages(response?.data);
  };

  useEffect(() => {
    if (!companyInfo?.department_id) return;
    handleGetUsageStats(dayjs().format(dateFormat), dayjs().format(dateFormat));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyInfo?.department_id]);

  return (
    <Page title="Raporlar | Boardnote">
      <FormControl sx={{ mx: 3, mb: 3, minWidth: 240 }}>
        <InputLabel id="range-select-label">Aralık</InputLabel>
        <Select
          labelId="range-select-label"
          id="range-select"
          value={selectedRange}
          label="Aralık"
          onChange={(e) => handleRangeChange(e.target.value)}
        >
          <MenuItem value="monthly">Aylık</MenuItem>
          <MenuItem value="3months">3 Aylık</MenuItem>
          <MenuItem value="6months">6 Aylık</MenuItem>
          <MenuItem value="yearly">Yıllık</MenuItem>
        </Select>
      </FormControl>
      <Card sx={{ mx: 3, p: 3, mb: 3 }}>
        <Bar data={data} options={options} />
      </Card>
    </Page>
  );
}
